"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.conditionApplies = conditionApplies;
const time_1 = require("./time");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const luxon_1 = require("luxon");
function conditionApplies(condition, scenario, timezone) {
    var _a;
    if (!condition || (0, isEmpty_1.default)(condition)) {
        return true;
    }
    if (condition.and) {
        if (!condition.and.every(clause => conditionApplies(clause, scenario, timezone))) {
            return false;
        }
    }
    if (condition.or) {
        if (!condition.or.some(clause => conditionApplies(clause, scenario, timezone))) {
            return false;
        }
    }
    if (condition.not) {
        if (conditionApplies(condition.not, scenario, timezone)) {
            return false;
        }
    }
    // Create DateTime with proper timezone handling
    const dateTime = timezone
        ? luxon_1.DateTime.fromISO(`${scenario.date}T${scenario.time}`, { zone: timezone })
        : luxon_1.DateTime.fromISO(`${scenario.date}T${scenario.time}`);
    if (condition.betweenTimes) {
        const [stime, etime] = condition.betweenTimes;
        if (!(0, time_1.withinTimeRange)(dateTime, stime, etime)) {
            return false;
        }
    }
    if (condition.betweenGuests) {
        const [min, max] = condition.betweenGuests;
        if (scenario.groupSize < min || scenario.groupSize > max) {
            return false;
        }
    }
    if (scenario.groupSize != null) {
        if (condition.minGuestCount != null && scenario.groupSize < condition.minGuestCount) {
            return false;
        }
        if (condition.maxGuestCount != null && scenario.groupSize > condition.maxGuestCount) {
            return false;
        }
    }
    if (condition.daysOfWeek && !(0, time_1.withinWeekdays)(dateTime, condition.daysOfWeek)) {
        return false;
    }
    if (condition.dates) {
        if (!(0, time_1.someDateMatches)(dateTime, condition.dates)) {
            return false;
        }
    }
    if (condition.betweenDates) {
        if (!(0, time_1.betweenDates)(dateTime, condition.betweenDates)) {
            return false;
        }
    }
    if (condition.leadTimeHours) {
        const now = luxon_1.DateTime.now();
        const reservationTime = dateTime;
        // Calculate hours difference with proper timezone handling
        const hoursUntilReservation = reservationTime.diff(now, 'hours').hours;
        if (hoursUntilReservation < condition.leadTimeHours) {
            return false;
        }
    }
    if (condition.hasItem) {
        const hasMatchingItem = (_a = scenario === null || scenario === void 0 ? void 0 : scenario.items) === null || _a === void 0 ? void 0 : _a.some(item => (!condition.hasItem.id || item.id === condition.hasItem.id) &&
            (!condition.hasItem.type || item.type === condition.hasItem.type));
        if (!hasMatchingItem) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=conditions.js.map